<section class="custom-modal" role="dialog" aria-modal="true" aria-labelledby="save-changes-title">
  <header class="modal-header">
    <div class="modal-header-text">
      <h2 id="save-changes-title" class="modal-title">Save Changes to Staff Access</h2>
      <p class="modal-subtitle">Review the changes below before saving. These cannot be undone.</p>
    </div>
    <button type="button" class="icon-button" aria-label="Close" (click)="onCancel()">
      <app-display-icon [border]="false" [colour]="iconColourEnum.primary" [icon]="icons.closeOutline">
      </app-display-icon>
    </button>
  </header>

  <div class="modal-body">
    @for (user of userChanges; track trackUser($index, user)) {
      <div class="change-card">
        <div class="change-card-header">
          <span class="change-user">{{ user.userName }}</span>
        </div>
        <p class="change-email">{{ user.userEmail }}</p>

        <div class="store-changes">
          @for (storeChange of user.storeChanges; track trackStoreChange($index, storeChange)) {
            <div class="store-change-row">
              <span class="change-store">{{ storeChange.storeName }}</span>
              <div class="change-comparison">
                <div class="change-column">
                  <span class="change-label">Before</span>
                  <span class="change-value change-value-before">{{ storeChange.beforeRole }}</span>
                </div>
                <app-display-icon
                  class="change-arrow"
                  [border]="false"
                  [colour]="iconColourEnum.primary"
                  [icon]="icons.arrowRight">
                </app-display-icon>
                <div class="change-column">
                  <span class="change-label">After</span>
                  <span class="change-value change-value-after">{{ storeChange.afterRole }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <footer class="modal-footer">
    <app-shared-button [colour]="'primary'" (click)="onCancel()">Cancel</app-shared-button>
    <app-shared-button [colour]="'primary'" [fill]="true" (click)="onConfirm()">Save Changes</app-shared-button>
  </footer>
</section>
